import type { RouteObject } from 'react-router-dom'
import { PendingReviewsPage } from './pages/PendingReviewsPage'
import { WriteReviewPage } from './pages/WriteReviewPage'

export const reviewsRoutes: RouteObject[] = [
  {
    index: true,
    element: <PendingReviewsPage />,
  },
  {
    path: 'write',
    element: <WriteReviewPage />,
  },
]
